export default (value: number) => `${value}rem`;
